// import {useRoles} from "@/src/modules/users/hooks";
import {useDarCodes, useDarTypes} from "@/src/modules/dars/hooks";
import {useDispatchLogTypes} from "@/src/modules/dispatch-logs/hooks";
import {useIncidentReportTypes} from "@/src/modules/incidents/hooks";

export default function useInit() {
  // const {isPending: isPendingUserRoles} = useRoles();
  const {isPending: isPendingDarCodes} = useDarCodes();
  const {isPending: isPendingDarTypes} = useDarTypes();
  const {isPending: isPendingIncidentReportTypes} = useIncidentReportTypes();
  const {isPending: isPendingDispatchLogTypes} = useDispatchLogTypes();

  const isPending =
    // isPendingUserRoles ||
    isPendingDarCodes ||
    isPendingDarTypes ||
    isPendingIncidentReportTypes ||
    isPendingDispatchLogTypes;

  return {isPending};
}
